import { type MessageDescriptor } from 'react-intl-next';

import { colorMessages } from './colorMessages';

export type ColorPalette<T = string> = {
  backgroundColor: (color: T) => string;
  textColor: (color: T) => string;
  borderColor?: (color: T) => string;
  hoverBackgroundColor?: (color: T) => string;
  swatch: () => readonly T[];
};

export const paletteColorsMap: Record<string, MessageDescriptor> = {
  greyLight: colorMessages['color-picker-label.greyLight'],
  blueLight: colorMessages['color-picker-label.blueLight'],
  tealLight: colorMessages['color-picker-label.tealLight'],
  greenLight: colorMessages['color-picker-label.greenLight'],
  limeLight: colorMessages['color-picker-label.limeLight'],
  purpleLight: colorMessages['color-picker-label.purpleLight'],
  magentaLight: colorMessages['color-picker-label.magentaLight'],
  redLight: colorMessages['color-picker-label.redLight'],
  orangeLight: colorMessages['color-picker-label.orangeLight'],
  yellowLight: colorMessages['color-picker-label.yellowLight'],
  greyDark: colorMessages['color-picker-label.greyDark'],
  blueDark: colorMessages['color-picker-label.blueDark'],
  tealDark: colorMessages['color-picker-label.tealDark'],
  greenDark: colorMessages['color-picker-label.greenDark'],
  limeDark: colorMessages['color-picker-label.limeDark'],
  purpleDark: colorMessages['color-picker-label.purpleDark'],
  magentaDark: colorMessages['color-picker-label.magentaDark'],
  redDark: colorMessages['color-picker-label.redDark'],
  orangeDark: colorMessages['color-picker-label.orangeDark'],
  yellowDark: colorMessages['color-picker-label.yellowDark']
};
